import React from 'react';
import classNames from 'classnames';
import { sendAnalyticsEvent } from 'shared/lib/analytics';

import styles from './styles.module.scss';

type LinkType = 'primary' | 'secondary';

type LinkProps = {
  children: React.ReactNode;
  type?: LinkType;
  className?: string;
  href?: string;
  target?: string;
  analyticsEventName?: string;
  gtmEventName?: string;
  onClick?: (e: React.MouseEvent<HTMLAnchorElement, MouseEvent>) => void;
};

const Link: React.FC<LinkProps> = ({
  children,
  type = 'primary',
  className,
  href,
  target,
  analyticsEventName,
  gtmEventName,
  onClick,
}) => {
  const classNamePrefix = 'link';
  const _className = classNames(
    className,
    styles[classNamePrefix],
    styles[`${classNamePrefix}-${type}`]
  );
  const dataGtmEventName = gtmEventName ?? analyticsEventName;
  const handleClick = (
    event: React.MouseEvent<HTMLAnchorElement, MouseEvent>
  ) => {
    if (analyticsEventName) {
      sendAnalyticsEvent(analyticsEventName);
    }

    onClick?.(event);
  };

  return (
    <a
      onClick={handleClick}
      href={href}
      className={_className}
      target={target}
      data-gtm-event-name={dataGtmEventName}
    >
      {children}
    </a>
  );
};

export { Link };
